import { MonthReport, ParkingUse, NotifyCount, NotifyRanking, MonthWallet } from './actions'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    MonthWallet,
    MonthReport,
    ParkingUse,
    NotifyCount,
    NotifyRanking
  }
}